"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGraphQLClient = exports.queryClient = exports.getGraphEndpointUrl = exports.endpoints = exports.basicHeaders = void 0;
var graphql_request_1 = require("graphql-request");
var react_query_1 = require("react-query");
exports.basicHeaders = {
    'Content-Type': 'application/json',
};
exports.endpoints = {
    devtest: 'https://appsync.devtest.esubcloud.io/graphql',
    dev: 'https://appsync.dev.esubcloud.io/graphql',
    qa: 'https://appsync.qa.esubcloud.io/graphql',
    stage: 'https://appsync.stage.esubcloud.io/graphql',
    demo: 'https://appsync.demo.esubcloud.io/graphql',
    prod: 'https://appsync.esubcloud.io/graphql',
    migration: 'https://appsync.migration.esubcloud.io/graphql',
    dr: 'https://appsync.dr.esubcloud.io/graphql',
};
var endpointMap = {
    'devtest.esubcloud.com': exports.endpoints.devtest,
    'dev.esubcloud.com': exports.endpoints.dev,
    'migration.esubcloud.com': exports.endpoints.migration,
    'qa.esubcloud.com': exports.endpoints.qa,
    'stage.esubcloud.com': exports.endpoints.stage,
    'demo.esubcloud.com': exports.endpoints.demo,
    'esubcloud.com': exports.endpoints.prod,
    'dr.esubcloud.com': exports.endpoints.dr,
};
var getGraphEndpointUrl = function (location, defaultEndpoint) {
    if (defaultEndpoint === void 0) { defaultEndpoint = exports.endpoints.dev; }
    var regex = /^https:\/\/(?:www\.)?(?:console\.)?(.+)/i;
    var matches = regex.exec("".concat(location));
    // NOTE: match[1] contains the origin used for endpoint mapping
    var matchingUrl = Object.keys(endpointMap).find(function (url) { return matches && matches[1].startsWith(url); });
    var endpoint = matchingUrl ? endpointMap[matchingUrl] : defaultEndpoint;
    // use map value OR default to dev
    return endpoint;
};
exports.getGraphEndpointUrl = getGraphEndpointUrl;
// use setQueryDefaults or setMutationDefaults to expand options at runtime
exports.queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            // staleTime: 3 * 60 * 1000,
            // refetchOnMount: false,
        },
    },
});
var getGraphQLClient = function (location, options) {
    if (options === void 0) { options = {}; }
    var defaultEndpoint = options.defaultEndpoint;
    return new graphql_request_1.GraphQLClient((0, exports.getGraphEndpointUrl)(location, defaultEndpoint), __assign({}, options));
};
exports.getGraphQLClient = getGraphQLClient;
